// removed by extract-text-webpack-plugin
module.exports = {"propertyRow":"_1rrf8tBxD11zJF69R0Ld5I","propertyName":"_12KLN8aXuaWF_yKYT-yEzu","propertyValue":"_1WcDBthdUIF1y6sCe8XWk2","progressContainer":"_3vm7HVhLxQCP-CuB-kkigW","progressStatusContainer":"m1xql56SoCeIEFYBXHDrr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectReport/ProjectReport.scss
// module id = 626
// module chunks = 1